import Cookies from "js-cookie";

export type UserRole = "USER" | "ADMIN" | "SUPERADMIN";

export type AdminUserInfo = {
  id: string;
  userName: string;
  coins: number;
  role: UserRole;
};

const USER_INFO_KEY = "admin_user_info";
const TOKEN_KEY = "access_token";

export function setAdminSession(params: { token: string; user: AdminUserInfo }) {
  Cookies.set(TOKEN_KEY, params.token, { expires: 1 / 24, sameSite: "Lax" });
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(params.user));
}

export function clearAdminSession() {
  Cookies.remove(TOKEN_KEY);
  localStorage.removeItem(USER_INFO_KEY);
}

export function getAdminUserInfo(): AdminUserInfo | null {
  const raw = localStorage.getItem(USER_INFO_KEY);
  return raw ? (JSON.parse(raw) as AdminUserInfo) : null;
}

export function isAdminAuthed(): boolean {
  const token = Cookies.get(TOKEN_KEY);
  const info = getAdminUserInfo();
  return !!token && (info?.role === "ADMIN" || info?.role === "SUPERADMIN");
}

